import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Stop.es.js";
const t = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(a, { ref: r, ...e, weights: m }));
t.displayName = "StopIcon";
const s = t;
export {
  s as Stop,
  t as StopIcon
};
